//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import flagType from '~/static/flagType.json';
import idType from '~/static/userProfile/idType.json';

export default {
  name: 'Register',
  data: function data() {
    return {
      // types: ['text', 'password', 'email', 'text'],
      userRegisterInfo: {
        username: '',
        password: '',
        confirmPassword: '',
        fullname: '',
        companyName: '',
        conEmail: '',
        dateOfBirth: '',
        nricFin: '',
        isActivated: false,
        idType: null,
        flag: null,
        createdFrom: 1001,
        workingProfile: {}
      },
      // selectedIdType: null,
      idType: idType /*[
                     {value: null, text: '=ID Type=', disabled:true, selected:true},
                     {value: 'NRIC', text:'NRIC'},
                     {value: 'FIN', text:'FIN'}
                     ]*/
      , confirmPassword: '',
      selectedUserFlag: null,
      userFlag: flagType
      /*[
          {value: null, text: '=Please Select Your Account Type=', disabled: true, selected:true},
          {value: 'Admin', text: 'Admin'},
          {value: 'Con', text: 'Contractor'},
          {value: 'Wkr', text: 'Worker'}
        ]*/
    };
  },

  computed: {
    passwordValidation: function passwordValidation() {
      var passwordRegExp = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,25}$/;
      return passwordRegExp.test(this.userRegisterInfo.password);
    },
    nricFinValidation: function nricFinValidation() {
      var nricFinRegExp = /^[A-Za-z]\d{7}[A-Za-z]$/i;
      return nricFinRegExp.test(this.userRegisterInfo.nricFin);
    }
  },
  methods: {
    userRegister: function userRegister() {
      // if(!!this.userRegisterInfo.username &&
      //   !!this.userRegisterInfo.password &&
      //   !!this.userRegisterInfo.confirmPassword &&
      //   !!this.userRegisterInfo.fullname &&
      //   !!this.userRegisterInfo.companyName &&
      //   !!this.userRegisterInfo.conEmail &&
      //   !!this.userRegisterInfo.nricFin &&
      //   !!this.userRegisterInfo.idType )// &&
      // {
      this.$emit('userRegister', this.userRegisterInfo);
      this.$refs['confirmRegInfo'].hide();
      this.userRegisterInfo = {
        username: '',
        password: '',
        confirmPassword: '',
        fullname: '',
        companyName: '',
        conEmail: '',
        dateOfBirth: '',
        nricFin: '',
        workingProfile: {},
        idType: null,
        flag: null
      };
      // }
      // else {
      //   alert("Please Fill Up All Fields Properly");
      // }
    },
    clearRegisterInfo: function clearRegisterInfo() {
      this.userRegisterInfo = {
        username: '',
        password: '',
        confirmPassword: '',
        fullname: '',
        companyName: '',
        conEmail: '',
        dateOfBirth: '',
        nricFin: '',
        createdFrom: 1001,
        workingProfile: {},
        idType: null,
        flag: null
      };
    },
    showConfirmModal: function showConfirmModal() {
      // this.$refs['confirmRegInfo'].show();

      if (!!this.userRegisterInfo.username && !!this.userRegisterInfo.password && !!this.userRegisterInfo.confirmPassword && !!this.userRegisterInfo.fullname && !!this.userRegisterInfo.companyName && !!this.userRegisterInfo.conEmail && !!this.userRegisterInfo.dateOfBirth && !!this.userRegisterInfo.nricFin && !!this.userRegisterInfo.idType) {
        // &&
        this.$refs['confirmRegInfo'].show();

        // this.$emit('userRegister', this.userRegisterInfo);
        // this.userRegisterInfo = {
        //   username:'',
        //   password:'',
        //   confirmPassword:'',
        //   fullname:'',
        //   companyName:'',
        //   conEmail:'',
        //   nricFin:'',
        //   workingProfile: {},
        //   idType:null,
        //   flag:null
        // }
      } else {
        alert('Please Fill Up All Fields Properly');
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Register.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Register.vue
// module chunks = 0 7 10